<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-11-21 13:59:06
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 18:17:09
 * @FilePath: \seller.sviptrader.com\src\views\teamManage\accountManage\components\deactivate\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" width="400px" :before-close="handClose">
		<div slot="title"> 提示 </div>
		<div class="flex-row-align-center">
			<i class="el-icon-warning mr-6 font-h2-regular" style="color: #ff7038"></i>
			<span class="ft-14">是否确认{{ isEnable ? '停用' : '启用' }}该账号？</span>
		</div>
		<p class="ml-24 mt-6" v-if="isEnable">停用子账号后，相应子账号登录后将展示没有访问权限的页面</p>
		<span slot="footer" class="dialog-footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="submit">{{ isEnable ? '确认停用' : '确认启用' }}</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { disableAccount, enableAccount } from '@/api/teamManage';
export default {
	data() {
		return {
			visible: false,
			userId: '',
			isEnable: true,
		};
	},
	methods: {
		show(userId, status) {
			this.userId = userId;
			this.isEnable = status === '1';
			this.visible = true;
		},
		async submit() {
			const { userId, isEnable } = this;
			const api = isEnable ? disableAccount : enableAccount;
			await api({ userId });
			this.$message.success('操作成功！');
			this.$emit('refresh');
			this.handClose();
		},
		handClose() {
			this.userId = '';
			this.visible = false;
			this.isEnable = true;
		},
	},
};
</script>
<style lang="'less'" scoped></style>
